<h2 mat-dialog-title class="reschedule-dialog__title">{{ dialogEnum.RESCHEDULE_DIALOG_HEADER }}</h2>
<mat-dialog-content>
  <p class="reschedule-dialog__body">{{ dialogEnum.RESCHEDULE_DIALOG_CONTENT }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="reschedule-dialog__actions">
  <button mat-dialog-close class="reschedule-dialog__btn reschedule-dialog__btn--ghost">Back to Booking</button>
  <button [mat-dialog-close]="true" class="reschedule-dialog__btn reschedule-dialog__btn--primary">
    Choose New Event
  </button>
</mat-dialog-actions>
